var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("generic-modal", {
        ref: "generateEmailModal",
        attrs: {
          id: "generate-email-modal",
          "modal-dialog-scrollable": false,
          "modal-dialog-size": "xl",
          "content-class": "generate-email-modal__content",
          "body-class": "generate-email-modal__body",
          "footer-class": "generate-email-modal__footer",
          "header-close-button": "",
          "modal-header": false,
          "footer-close-button": false,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { attrs: { id: "generate-email-container" } }, [
                  _c(
                    "div",
                    { staticClass: "section" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.words.email-type")) +
                          "\n          "
                      ),
                      _c(
                        "material-input",
                        [
                          _c("v-select-field", {
                            staticClass: "simple-dd",
                            attrs: {
                              id: "purpose-dropdown",
                              label: "text",
                              options: _vm.purposeOptions,
                              "default-value": _vm.selectedPurpose,
                              scenario: "simple",
                              "d-block": "",
                            },
                            on: {
                              "option:selected": _vm.selectMailPurpose,
                              clear: function ($event) {
                                _vm.selectedPurpose = 12
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.tone")) +
                        "\n          "
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-section",
                        attrs: { "d-block": "" },
                      },
                      [
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedTone,
                                expression: "selectedTone",
                              },
                            ],
                            attrs: { type: "radio", value: "professional" },
                            domProps: {
                              checked: _vm._q(_vm.selectedTone, "professional"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedTone = "professional"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t("application-form.professional")
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedTone,
                                expression: "selectedTone",
                              },
                            ],
                            attrs: { type: "radio", value: "casual" },
                            domProps: {
                              checked: _vm._q(_vm.selectedTone, "casual"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedTone = "casual"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(_vm._s(_vm.$t("global.words.casual"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedTone,
                                expression: "selectedTone",
                              },
                            ],
                            attrs: { type: "radio", value: "funny" },
                            domProps: {
                              checked: _vm._q(_vm.selectedTone, "funny"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedTone = "funny"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(_vm._s(_vm.$t("global.words.funny"))),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.length")) +
                        "\n          "
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-section",
                        attrs: { "d-block": "" },
                      },
                      [
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLength,
                                expression: "selectedLength",
                              },
                            ],
                            attrs: { type: "radio", value: "short" },
                            domProps: {
                              checked: _vm._q(_vm.selectedLength, "short"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedLength = "short"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("global.words.short")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLength,
                                expression: "selectedLength",
                              },
                            ],
                            attrs: { type: "radio", value: "medium" },
                            domProps: {
                              checked: _vm._q(_vm.selectedLength, "medium"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedLength = "medium"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(_vm._s(_vm.$t("global.words.medium"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLength,
                                expression: "selectedLength",
                              },
                            ],
                            attrs: { type: "radio", value: "long" },
                            domProps: {
                              checked: _vm._q(_vm.selectedLength, "long"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedLength = "long"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(_vm._s(_vm.$t("global.words.long"))),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("direct-to-lender.lenderSubmit.language")
                        ) +
                        ":\n          "
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-section",
                        attrs: { "d-block": "" },
                      },
                      [
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLanguage,
                                expression: "selectedLanguage",
                              },
                            ],
                            attrs: { type: "radio", value: "en-CA" },
                            domProps: {
                              checked: _vm._q(_vm.selectedLanguage, "en-CA"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedLanguage = "en-CA"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("global.words.english")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "pill-select-item" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLanguage,
                                expression: "selectedLanguage",
                              },
                            ],
                            attrs: { type: "radio", value: "fr-CA" },
                            domProps: {
                              checked: _vm._q(_vm.selectedLanguage, "fr-CA"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.selectedLanguage = "fr-CA"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pill-select-label" }, [
                            _vm._v(_vm._s(_vm.$t("global.words.french"))),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.selectedPurpose === 12
                    ? _c(
                        "div",
                        {
                          staticClass: "section custom-textarea",
                          staticStyle: { "grid-column": "span 2" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "custom-textarea-header" },
                            [
                              _c("h5", [
                                _vm._v(
                                  _vm._s(_vm.$t("global.words.instructions"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("ai-email-templates-dropdown", {
                                attrs: {
                                  "show-load-option": _vm.showLoadOption,
                                  loading: _vm.savedPromptsLoading,
                                },
                                on: { "open-modal": _vm.openPromptModal },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("material-input", [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.customPrompt,
                                  expression: "customPrompt",
                                },
                              ],
                              staticClass: "w-100 pl-4",
                              attrs: {
                                rows: "6",
                                placeholder: _vm.$t("email.custom.placeholder"),
                              },
                              domProps: { value: _vm.customPrompt },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.customPrompt = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { id: "container-footer" } },
                    [
                      _c("simple-button", {
                        attrs: {
                          text: _vm.$t("global.actions.setDefault"),
                          type: "white",
                          loading: _vm.loading,
                        },
                        on: { click: _vm.handleSetDefault },
                      }),
                      _vm._v(" "),
                      _c("simple-button", {
                        attrs: {
                          text: _vm.$t("global.actions.generateDraft"),
                          disabled:
                            _vm.selectedPurpose == -1 ||
                            (_vm.selectedPurpose === 12 && !_vm.customPrompt),
                        },
                        on: { click: _vm.handleGenerateEmail },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "result-container-custom": _vm.selectedPurpose === 12,
                    },
                    attrs: { id: "result-container" },
                  },
                  [
                    _c("h5", [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.results"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.textareaValue == "loading"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center vertical-center h-100",
                          },
                          [
                            _c("div", {
                              staticClass: "spinner-border text-primary mb-5",
                              staticStyle: { height: "5rem", width: "5rem" },
                              attrs: { role: "status" },
                            }),
                          ]
                        )
                      : _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.textareaValue,
                              expression: "textareaValue",
                            },
                          ],
                          ref: "aiGeneratedEmailEditor",
                          attrs: {
                            id: "generated-email-editor-wrapper-textarea",
                            rows: "12",
                          },
                          domProps: { value: _vm.textareaValue },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.textareaValue = $event.target.value
                            },
                          },
                        }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          background: "gainsboro",
                          "border-radius": "4px",
                          padding: "10px",
                        },
                      },
                      [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "direct-to-lender.lenderSubmit.AIGeneratedContentDisclaimer"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "w-100", attrs: { id: "btn-container" } },
                  [
                    _c(
                      "b-row",
                      {
                        staticClass:
                          "d-flex justify-content-end auto-compose-footer-actions",
                      },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c("simple-button", {
                              staticClass: "order-1",
                              attrs: {
                                id: "back",
                                text: _vm.$t("global.words.close"),
                                type: "white",
                              },
                              on: { click: _vm.closeModal },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c("simple-button", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: _vm.showToolTip
                                    ? {
                                        title: _vm.$t(
                                          "email.actions.onlyMainApplicant"
                                        ),
                                      }
                                    : "",
                                  expression:
                                    "\n                showToolTip\n                  ? {\n                      title: $t('email.actions.onlyMainApplicant')\n                    }\n                  : ''\n              ",
                                },
                              ],
                              staticClass: "confirm",
                              attrs: {
                                text:
                                  _vm.buttonText == "save"
                                    ? _vm.$t(
                                        "direct-to-lender.lenderSubmit.save"
                                      )
                                    : _vm.$t(
                                        "application.applicationHeader.sendEmail"
                                      ),
                                disabled: _vm.sendEmailButtonDisabled,
                              },
                              on: { click: _vm.handleButton },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("ai-email-template-modal", {
        ref: "aiEmailTemplateModal",
        attrs: {
          type: _vm.modalType,
          "custom-prompt": _vm.customPrompt,
          "saved-prompts": _vm.savedPrompts,
        },
        on: {
          "close-modal": _vm.loadSavedPrompts,
          "load-prompt": _vm.handleLoadPrompt,
          "prompt-updated": _vm.loadSavedPrompts,
          "prompt-deleted": _vm.loadSavedPrompts,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }